import { LazyDialogInstance } from "../dialog-instance/LazyDialogInstance";
import { dialogDirector } from "../dialog-director/DialogDirector.const";
import { IMultiStepDialogInstanceConfig } from "../dialog-instance/interfaces/IMultiStepDialogInstanceConfig";

export function launchMultiStepDialog<TModel>(config: IMultiStepDialogInstanceConfig<TModel>): LazyDialogInstance<TModel> {
    const lazyInstance = new LazyDialogInstance<TModel>(config);

    lazyInstance.load(dialogDirector);

    return lazyInstance;
}
